import { AutojobSearchFilter } from 'src/modules/dashboard/models/autojobsSearchFilter';
import { AutojobResponse } from 'src/modules/dashboard/models/autojobResponse';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';

const controller = 'Autojob';

// export const getLatestAutojobs = (options: AutojobSearchFilter) => {
//   const endpoint = `${controller}/Latest`;
//   return AxiosInstance.get<PagedResult<AutojobResponse>>(endpoint, { params: options });
// };
// export const getUpcomingAutojobs = (options: AutojobSearchFilter) => {
//   const endpoint = `${controller}/Upcoming`;
//   return AxiosInstance.get<PagedResult<AutojobResponse>>(endpoint, { params: options });
// };
export const getAllAutojobs = (options: AutojobSearchFilter) => {
  const endpoint = `${controller}`;
  return AxiosInstance.get<PagedResult<AutojobResponse>>(endpoint, { params: options });
};
export const getAutojobById = (id: number | undefined) => {
  return AxiosInstance.get<AutojobResponse>(`${controller}/${id}`);
};

const controller2 = 'Autojob2';

export const getAllAutojobs2 = (options: AutojobSearchFilter) => {
  const endpoint = `${controller2}`;
  return AxiosInstance.get<PagedResult<AutojobResponse>>(endpoint, { params: options });
};
export const getAutojob2ById = (id: number | undefined) => {
  return AxiosInstance.get<AutojobResponse>(`${controller2}/${id}`);
};

export type CreateAutojob2Request = {
  taskName: string;
  assemblyName: string;
  scheduleType: number;
  increaseNum: number;
  startTimeStamp: string;
  custom1: string;
  custom2: string;
  custom3: string;
  custom4: string;
  custom5: string;
  custom6: string;
  custom7: string;
  custom8: string;
  custom9: string;
  custom10: string;
  custom11: string;
  custom12: string;
};

export const createAutojob2 = (data: CreateAutojob2Request) => {
  return AxiosInstance.post(`${controller2}`, data);
};
